module.exports = __webpack_public_path__ + "static/media/C4.77204bd9.png";